import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { EditProfileComponent } from "./edit-profile/edit-profile.component";
import { ViewsComponent } from "./views/views.component";
import { AuthGuard } from "./_helpers/auth.guard.service";

const routes: Routes = [
  {
    path: "auth",
    loadChildren: () => import("./auth/auth.module").then((m) => m.AuthModule),
  },

  { path: "", redirectTo: "auth", pathMatch: "full" },
  {
    path: "edit-profile",
    component: EditProfileComponent,
  },
  {
    path: "",
    component: ViewsComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "change-password", component: EditProfileComponent },

      {
        path: "dashboard",
        loadChildren: () =>
          import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
      },



      {
        path: "analytics-dashboard",
        loadChildren: () =>
        import("../app/dashboard/dashboard.module").then(
          (m) => m.DashboardModule
        )
      },



      {
        path: "Waitlist-form",
        loadChildren: () =>
          import("./views/manage-toplistings/manage-toplistings.module").then(
            (m) => m.ManageCaregiversModule
          ),
      },


      {
        path: "manage/clients",
        loadChildren: () =>
          import("./views/manage-businesses/manage-businesses.module").then(
            (m) => m.ManageClientsModule
          ),
      },



   

      {
        path: "Leagues-list",
        loadChildren: () =>
          import("./views/manage-analytics/manage-analytics.module").then(
            (m) => m.ManageTaxesModule
          ),
      },
      {
        path: "manage-deleted",
        loadChildren: () =>
        import("./views/manage-deleted/manage-deleted.module").then(
          (m) => m.ManageDeletedModule
        )
      },

      {
        path: "Leagues-view",
        loadChildren: () =>
          import("./views/manage-analytics/manage-analytics-view/manage-analytics-view.component").then(
            (m) => m.ManageAnalyticsViewComponent
          ),
      },

      {
        path: "Leagues-details",
        loadChildren: () =>
          import("./views/manage-analytics/manage-analytics-details/manage-analytics-details.component").then(
            (m) => m.ManageAnalyticsDetailsComponent
          ),
      },

     

     
     


      {
        path: "Sports-type",
        loadChildren: () =>
          import("./views/manage-servicecategories/manage-servicecategories.module").then(
            (m) => m.ManageDiseasesModule
          ),
      },

      {
        path: "league-category",
        loadChildren: () =>
          import("./views/manage-sub/manage-sub.module").then(
            (m) => m.ManageSubModule
          ),
      },


      {
        path: "league-admin",
        loadChildren: () =>
          import("./views/manage-service/manage-service.module").then(
            (m) => m.ManageServiceModule
          ),
      },

    ],
  },
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
